export enum HotelRoomType {
  INDIVIDUAL = 'INDIVIDUAL',
  DOUBLE = 'DOUBLE',
  TRIPLE = 'TRIPLE',
  QUADRUPLE = 'QUADRUPLE',
}

export const HOTEL_ROOM_TYPES: Array<HotelRoomType> = [
  HotelRoomType.INDIVIDUAL,
  HotelRoomType.DOUBLE,
  HotelRoomType.TRIPLE,
  HotelRoomType.QUADRUPLE,
];

export const INDIVIDUAL_ROOM_COMBINATIONS = [[1, 0, 0]];
export const DOUBLE_ROOM_COMBINATIONS = [
  [2, 0, 0],
  [1, 0, 1],
  [1, 1, 0],
];
export const TRIPLE_ROOM_COMBINATIONS = [
  [3, 0, 0],
  [2, 0, 1],
  [1, 0, 2],
  [2, 1, 0],
  [1, 2, 0],
  [1, 1, 1],
];
export const QUADRUPLE_ROOM_COMBINATIONS = [
  [4, 0, 0],
  [3, 0, 1],
  [2, 0, 2],
  [1, 0, 3],
  [3, 1, 0],
  [2, 2, 0],
  [1, 3, 0],
  [2, 1, 1],
  [1, 1, 2],
  [1, 2, 1],
];

export const getHotelRoomCombinations = (
  hotelRoomType: HotelRoomType,
  numberOfDistributions: number = 0,
) => {
  switch (hotelRoomType) {
    case HotelRoomType.INDIVIDUAL:
      return INDIVIDUAL_ROOM_COMBINATIONS.map((values, index) => ({
        combination: values.slice(0, numberOfDistributions + 1),
        index: index,
      }));
    case HotelRoomType.DOUBLE:
      return DOUBLE_ROOM_COMBINATIONS.map((values, index) => ({
        combination: values,
        index: index,
      }))
        .filter(({ combination }) =>
          numberOfDistributions === 0
            ? combination[1] === 0 && combination[2] === 0
            : numberOfDistributions === 1
              ? combination[2] === 0
              : true,
        )
        .map(({ combination, index }) => ({
          combination: combination.slice(0, numberOfDistributions + 1),
          index,
        }));
    case HotelRoomType.TRIPLE:
      return TRIPLE_ROOM_COMBINATIONS.map((values, index) => ({
        combination: values,
        index: index,
      }))
        .filter(({ combination }) =>
          numberOfDistributions === 0
            ? combination[1] === 0 && combination[2] === 0
            : numberOfDistributions === 1
              ? combination[2] === 0
              : true,
        )
        .map(({ combination, index }) => ({
          combination: combination.slice(0, numberOfDistributions + 1),
          index,
        }));
    case HotelRoomType.QUADRUPLE:
      return QUADRUPLE_ROOM_COMBINATIONS.map((values, index) => ({
        combination: values,
        index: index,
      }))
        .filter(({ combination }) =>
          numberOfDistributions === 0
            ? combination[1] === 0 && combination[2] === 0
            : numberOfDistributions === 1
              ? combination[2] === 0
              : true,
        )
        .map(({ combination, index }) => ({
          combination: combination.slice(0, numberOfDistributions + 1),
          index,
        }));
  }
};
